import { useCallback, useRef, useState } from 'react';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { RFValue } from 'react-native-responsive-fontsize';
import { FILTER_BAR_OVERLAY_TOP } from './chipLayout';

export function useFilterPickerAnchor() {
  const insets = useSafeAreaInsets();
  const dropdownRef = useRef(null);
  const [anchor, setAnchor] = useState(undefined);
  const [visible, setVisible] = useState(false);

  const fallbackTop = insets.top + RFValue(FILTER_BAR_OVERLAY_TOP);

  const open = useCallback(() => {
    dropdownRef.current?.measureInWindow((left, top, width, height) => {
      setAnchor({ top, left, width, height });
      setVisible(true);
    });
  }, []);

  const close = useCallback(() => {
    setVisible(false);
  }, []);

  return {
    dropdownRef,
    anchor,
    fallbackTop,
    visible,
    open,
    close,
  };
}

export default useFilterPickerAnchor;
